import { render, staticRenderFns } from "./chanting-set.vue?vue&type=template&id=e0d5dce6"
import script from "./chanting-set.vue?vue&type=script&lang=js"
export * from "./chanting-set.vue?vue&type=script&lang=js"
import style0 from "./chanting-set.vue?vue&type=style&index=0&id=e0d5dce6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports